import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Login from '../components/Login';
import TenWaysToWow from '../components/TenWaysToWow';
import NotFound from '../components/NotFound';

const AppRouter = () => (
  <BrowserRouter>
    <Switch>
      <Route path="/" component={TenWaysToWow} exact={true} />
      <Route path="/wow/:emailAddress/:contentId" component={TenWaysToWow} />
      <Route component={TenWaysToWow} />
    </Switch>
  </BrowserRouter>
);

export default AppRouter;



// WEBPACK FOOTER //
// ./src/routers/AppRouter.js